// extracted by mini-css-extract-plugin
export default {"login":"Login_login__DemPn","loginCard":"Login_loginCard__bx28g","form":"Login_form__PtJxd","btn":"Login_btn__Go9Pg"};